module.exports = __webpack_public_path__ + "img/parallel-car01.8d2f5451.jpg";